import React from 'react';
import styled, {css} from 'styled-components';

const StyledText = styled.span`
    font-weight: 500;
    font-size: 24px;
    line-height: 60px;
    font-family: Nunito Sans, sans-serif;
    width: 100%;
    max-width: 731px;

    //${props => props.margin && css`margin: ${props.margin};`}
`;

const HeaderText = (props)=> (
    <StyledText
        {...props}
    >
        {props.children}
    </StyledText>
);

export default HeaderText;